if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        if (window.innerWidth <= 768) {
          this.handleProductMedia(false);
        }
      }

      show(opener) {
        super.show(opener);
        if (window.innerWidth <= 768) {
          this.handleProductMedia(true);
        } else {
          this.showActiveMedia();
        }
      }

      handleProductMedia(show) {
        if (show) {
          const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.sectionId}`).cloneNode(true);
          const originalActiveThumbnail = mediaGallery.querySelector('[aria-current="true"]');
          const activeMediaId = originalActiveThumbnail.parentElement.getAttribute('data-target');
          mediaGallery.classList.add('active');
          mediaGallery.id = `MediaGallery-ProductModal-${this.dataset.sectionId}`;
          const replacedHtml = document
            .getElementById(`MediaGallery-${this.dataset.sectionId}`)
            .innerHTML.replace(/<modal-opener/g, '<div')
            .replace(/<\/modal-opener>/g, '</div>')
            .replace(
              new RegExp(`GalleryViewer-${this.dataset.sectionId}`, 'g'),
              `GalleryViewer-ProductModal-${this.dataset.sectionId}`
            )
            .replace(
              new RegExp(`GalleryStatus-${this.dataset.sectionId}`, 'g'),
              `GalleryStatus-ProductModal-${this.dataset.sectionId}`
            )
            .replace(
              new RegExp(`Slider-Gallery-${this.dataset.sectionId}`, 'g'),
              `Slider-Gallery-ProductModal-${this.dataset.sectionId}`
            )
            .replace(new RegExp(`Slide-${this.dataset.sectionId}`, 'g'), `Slide-ProductModal-${this.dataset.sectionId}`)
            .replace(
              new RegExp(`Slide-Thumbnail-${this.dataset.sectionId}`, 'g'),
              `Slide-Thumbnail-ProductModal-${this.dataset.sectionId}`
            )
            .replace(
              new RegExp(`GalleryThumbnails-${this.dataset.sectionId}`, 'g'),
              `GalleryThumbnails-ProductModal-${this.dataset.sectionId}`
            );
          mediaGallery.innerHTML = replacedHtml;
          this.querySelector('.product-media-modal__content').appendChild(mediaGallery);
          this.classList.add('media-modal--gallery');
          setTimeout(() => {
            initializeScrollAnimationTrigger(mediaGallery, true);
            const currentActiveThumbnail = mediaGallery.querySelector(`[data-target="${activeMediaId}"]`);
            if (currentActiveThumbnail) {
              currentActiveThumbnail.querySelector('button').click();
            }
          }, 0);
        } else {
          const mediaGallery = document.getElementById(`MediaGallery-ProductModal-${this.dataset.sectionId}`);
          if (mediaGallery) {
            mediaGallery.remove();
          }
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
